import Logo from '@/components/feature/Logo';
import { contactInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <Logo dark />
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-8 text-sm text-secondary-100">
          <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 cursor-pointer hover:text-accent-400 whitespace-nowrap transition-colors">
            <span className="w-4 h-4 flex items-center justify-center text-accent-400"><i className="ri-mail-line"></i></span>{contactInfo.email}
          </a>
        </div>
      </div>
      <div className="border-t border-secondary-400/40">
        <p className="max-w-6xl mx-auto px-4 md:px-6 py-5 text-xs text-secondary-300">© 2026 Let Me Clean</p>
      </div>
    </footer>
  );
}